import React, { useEffect, useState } from "react";
import { DataTable, TableColumnDef } from "../../components/DataTable";
import { ApiGet, ApiPut } from "../../helpers/API/ApiData";
import { Box, Paper, Typography, Button, CircularProgress } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { usePermissions } from "../../hooks/usePermissions";
import { PageHeader } from "../../components/PageHeader";

const Users = () => {
  // Permission-based access control
  const { canEdit } = usePermissions("/users");

  // pagination
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [countPerPage, setCountPerPage] = useState(10);
  const [isDocumentData, setIsDocumentData] = useState<any>();
  const [loadingData, setLoadingData] = useState(false);

  const [search, setSearch] = useState("");

  useEffect(() => {
    getAllHelp();
  }, [page, countPerPage, search]);

  const getAllHelp = async () => {
    setLoadingData(true);

    await ApiGet(
      `user/find-for-admin?letter=${search}&page=${page}&limit=${countPerPage}`
    )
      .then((res: any) => {
        setLoadingData(false);
        setIsDocumentData(res?.data?.data);
        setCount(res?.data?.count ?? 0);
      })
      .catch((error: any) => {
        setLoadingData(false);
      });
  };

  const userChangeStatus = async (row: any) => {
    const BlockedUser: any = {
      status: "blocked",
    };

    const ActiveUser: any = {
      status: "active",
    };

    await ApiPut(
      `user/active-and-blocked?id=${row?._id}`,
      row?.status?.name === "active" ? BlockedUser : ActiveUser
    )
      .then((res) => {
        toast.success("Status aktualisiert");
        getAllHelp();
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen. Bitte versuche es erneut");
      });
  };

  const columns: TableColumnDef[] = [
    {
      header: "Vorname",
      render: (row: any) => row?.firstName ? row?.firstName : "-",
      getValue: (row: any) => row?.firstName,
    },
    {
      header: "Nachname",
      render: (row: any) => row?.lastName ? row?.lastName : "-",
      getValue: (row: any) => row?.lastName,
    },
    {
      header: "E-Mail",
      render: (row: any) => row?.emailId ? row?.emailId : "-",
      getValue: (row: any) => row?.emailId,
    },
    {
      header: "Telefon",
      render: (row: any) => row?.phoneNo ? row?.phoneNo : "-",
      getValue: (row: any) => row?.phoneNo,
    },
    {
      header: "Mieter Name",
      render: (row: any) => row?.adminId?.adminName,
      getValue: (row: any) => row?.adminId?.adminName,
    },
    {
      header: "Mieter E-Mail",
      render: (row: any) => row?.adminId?.emailId,
      getValue: (row: any) => row?.adminId?.emailId,
    },
    {
      header: "Status",
      render: (row: any) => (
        <Box>
          {canEdit ? (
            row?.status?.name === "active" ? (
              <Button
                variant="contained"
                color="success"
                sx={{ whiteSpace: "nowrap" }}
                onClick={() => userChangeStatus(row)}
              >
                Aktiv{" "}
              </Button>
            ) : (
              <Button
                variant="contained"
                color="error"
                sx={{ whiteSpace: "nowrap" }}
                onClick={() => userChangeStatus(row)}
              >
                {" "}
                Inaktiv
              </Button>
            )
          ) : (
            <Typography
              variant="caption"
              sx={{
                px: 1,
                py: 0.5,
                borderRadius: 1,
                color: "white",
                bgcolor: row?.status?.name === "active" ? "success.main" : "error.main",
              }}
            >
              {row?.status?.name === "active" ? "Aktiv" : "Inaktiv"}
            </Typography>
          )}
        </Box>
      ),
    },
  ];

  return (
    <>
      <ToastContainer />
      <Paper sx={{ p: 1 }}>
        <Box sx={{ p: 2, mb: 2 }}>
          <PageHeader title="Benutzer:in" onSearch={(val) => { setSearch(val); setPage(1); }} />

          {loadingData ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <DataTable
              rows={isDocumentData || []}
              columns={columns}
              page={page}
              count={count}
              rowsPerPage={countPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setCountPerPage}
            />
          )}
        </Box>
      </Paper>
    </>
  );
};

export default Users;
